import { createSelector } from 'reselect';

import { selectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const solarSiteOptionSelector = state => state.entities.solarSiteOptions;

export const getSolarSiteOptionForSelectedSite = createSelector(
  solarSiteOptionSelector,
  selectedStructure,
  (options, site) => options.find(value => value.get('site', -1) == site, null, null),
);
